// extracted by mini-css-extract-plugin
module.exports = {"box":"_3PdBYuyDOWnAIq6aA33FfE","dots":"_2LBaVN9AasFqwOI4gWYryM"};